import type { FC } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './lib/AuthProvider';
import { ProtectedRoute } from './lib/ProtectedRoute';
import SupervisorLogin from './components/SupervisorLogin/SupervisorLogin';
import SupervisorRegistration from './components/SupervisorRegistration/SupervisorRegistration';
import StudentLogin from './components/StudentLogin/StudentLogin';
import StudentRegistration from './components/StudentRegistration/StudentRegistration';
import RegistrationSuccess from './components/Registration/RegistrationSuccess';
import VerifyEmail from './components/Registration/VerifyEmail';
import StudentHome from './components/StudentHome/Home/StudentHome';
import Profile from './components/StudentHome/Profile/Profile';
import Progress from './components/StudentHome/Progress/Progress';
import StudentAttendance from './components/StudentHome/Studentattendance/StudentAttendance';
import StudentFeedback from './components/StudentHome/StudentFeedback/StudentFeedback';
import OJTCoordinatorHome from './components/OJTCoordinator/OJTCoordinatorHome';
import ReceiveFeedback from './components/OJTCoordinator/ReceiveFeedback/ReceiveFeedback';
import SupervisorHome from './components/SupervisorHome/SupervisorHome';
import SupervisorFeedback from './components/SupervisorHome/SupervisorFeedback/SupervisorFeedback';
import AttendanceApproval from './components/SupervisorHome/AttendanceApproval/AttendanceApproval';

const App: FC = () => {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<StudentLogin />} />
            <Route path="/supervisor" element={<SupervisorLogin />} />
            <Route path="/student-registration" element={<StudentRegistration />} />
            <Route path="/registration" element={<Navigate to="/student-registration" replace />} />
            <Route path="/register" element={<Navigate to="/student-registration" replace />} />
            <Route path="/supervisor-registration" element={<SupervisorRegistration />} />
            <Route path="/registration-success" element={<RegistrationSuccess />} />
            <Route path="/verify" element={<VerifyEmail />} />
            <Route
              path="/ojt-coordinator/home" 
              element={
                <ProtectedRoute requiredRole="ojt_coordinator">
                  <OJTCoordinatorHome />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/ojt-coordinator/trainees" 
              element={
                <ProtectedRoute requiredRole="ojt_coordinator">
                  <OJTCoordinatorHome />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/ojt-coordinator/feedback" 
              element={
                <ProtectedRoute requiredRole="ojt_coordinator">
                  <ReceiveFeedback />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/supervisor/home" 
              element={
                <ProtectedRoute requiredRole="supervisor">
                  <SupervisorHome />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/supervisor/feedback" 
              element={
                <ProtectedRoute requiredRole="supervisor">
                  <SupervisorFeedback />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/supervisor/attendance" 
              element={
                <ProtectedRoute requiredRole="supervisor">
                  <AttendanceApproval />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/student/home" 
              element={
                <ProtectedRoute requiredRole="student">
                  <StudentHome />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/student/profile" 
              element={
                <ProtectedRoute requiredRole="student">
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/student/progress"
              element={
                <ProtectedRoute requiredRole="student">
                  <Progress />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/student/attendance"
              element={
                <ProtectedRoute requiredRole="student">
                  <StudentAttendance />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/student/feedback"
              element={
                <ProtectedRoute requiredRole="student">
                  <StudentFeedback />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
